/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'lifeScenario/goals': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g transform="translate(-2 -2)" _fill="none" fill-rule="evenodd"><path pid="0" d="M20 12h2a10 10 0 01-20 0C2 6.477 6.477 2 12 2a1 1 0 010 2 8 8 0 108 8 1 1 0 112 0 1 1 0 01-2 0zm-4 0a1 1 0 012 0 6 6 0 11-6-6 1 1 0 010 2 4 4 0 104 4zm-1-6l4-4v3h3l-4 4h-1.5l-2.55 2.55c.05.15.05.3.05.45a2 2 0 11-2-2c.15 0 .3 0 .45.05L15 7.5V6z" _fill="#2CB6F8"/><circle pid="1" _fill="#004CD0" cx="21" cy="12" r="1"/></g>'
  }
})
